import React from 'react';
import I18n from 'i18n-js';
import { RCModal } from '@reverbdotcom/cadence/components';

interface BumpModalShellProps {
  isOpen: boolean;
  onRequestClose: () => void;
  bid: number;
  showCustomWarning: boolean;
  onSubmit: () => void;
  onNoThankYou: () => void;
  children: React.ReactNode;
}

export function BumpModalShell({
  isOpen,
  onRequestClose,
  bid,
  showCustomWarning,
  onSubmit,
  onNoThankYou,
  children,
}: BumpModalShellProps) {
  const isCancelDismiss = bid > 0;
  const cancelButtonText = isCancelDismiss
    ? I18n.t('discovery.bumpModal.cancel')
    : I18n.t('discovery.bumpModal.noThankYou');

  return (
    <RCModal
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) onRequestClose();
      }}
      title={I18n.t('discovery.bumpModal.title')}
      actions={{
        primary: {
          buttonText: I18n.t('discovery.bumpModal.saveAndApply'),
          onClick: onSubmit,
          disabled: showCustomWarning,
          preventCloseOnClick: true,
        },
        secondary: {
          buttonText: cancelButtonText,
          onClick: isCancelDismiss ? onRequestClose : onNoThankYou,
        },
      }}
    >
      {children}
    </RCModal>
  );
}
